<form name="TaxCategorySlabForm" (ngSubmit)="Validate(TaxCategorySlabForm)" #TaxCategorySlabForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Tax Sub Section</label>
        </div>
        <div class="card-body">
            <div class="row">
                <!-- <div class="col px-1 pt-2">
                    <label>Financial Year Start</label>
                    <div class="input-group mb-3">
                        <input type="number" class="form-control" placeholder="Ex. 2024" id="FinancialYearStart"
                            name="FinancialYearStart" [(ngModel)]="Detail.YearStart" #FinancialYearStart="ngModel"
                            pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)" maxlength="4"
                            (change)="SetFinancialYearEnd()" required>
                        <span class="input-group-text" id="Year">Year</span>
                        <div class="invalid-feedback">
                            Please enter financial year start.
                        </div>
                    </div>
                </div>
                <div class="col px-1 pt-2">
                    <label>Financial Year End</label>
                    <div class="input-group mb-3">
                        <input type="number" class="form-control" placeholder="Ex. 2025" id="FinancialYearEnd"
                            name="FinancialYearEnd" [(ngModel)]="Detail.YearEnd" #FinancialYearEnd="ngModel"
                            pattern="^[0-9]\d*$" maxlength="4" (keypress)="common.NumberOnly($event)" required disabled>
                        <span class="input-group-text" id="Year">Year</span>
                        <div class="invalid-feedback">
                            Please enter financial year end.
                        </div>
                    </div>
                </div> -->
                <div class="col px-1 pt-2">
                    <label>Financial Year</label>
                    <ng-select name="FinancialYear" [items]="FinancialYears" bindLabel="FinancialYear"
                        bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Detail.ESS_TaxFinancialYearID"
                        placeholder="Financial Year" (change)="clear(1)" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select financial year.
                    </div>
                </div>
                <div class="col-auto px-1 pt-2" style="align-content:end">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="TaxSectionMasterSelectLoad()"
                        [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                        Find Section
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 px-1 pt-2">
                    <label>Section</label>
                    <ng-select name="ESS_TaxSectionMasterID" [items]="TaxSections" bindLabel="SectionLabel"
                        bindValue="ESS_TaxSectionMasterID" [(ngModel)]="Detail.ESS_TaxSectionMasterID"
                        placeholder="Tax Sections" (change)="ESS_TaxSubSectionMasterSelect();clear(2);GetDesc('Section')" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select section.
                    </div>
                </div>
                <!-- <div class="col-md-12 px-1 pt-2">
                    <label>Section Description</label>
                    <textarea type="text" class="form-control" placeholder="Ex. Section Description"
                        id="SectionDescription" name="SectionDescription"
                        [(ngModel)]="this.Detail.SectionDescription" #SectionDescription="ngModel"
                        disabled></textarea>
                </div> -->
                <div class="col-md-12 px-1 pt-2">
                    <label>Sub Section</label>
                    <ng-select name="ESS_TaxSubSectionMasterID" [items]="TaxSubSections" bindLabel="SubSectionName"
                        bindValue="ESS_TaxSubSectionMasterID" [(ngModel)]="Detail.ESS_TaxSubSectionMasterID"
                        placeholder="Tax Sub Sections" (change)="GetDesc('SubSection')" required>
                    </ng-select>
                    <span class="badge bg-secondary small m-1"
                        style="float:right">{{this.Detail.EarningDeduction}}</span>
                    <div class="invalid-feedback">
                        Please select sub section.
                    </div>
                </div>
                <div class="col-md-12 px-1 pt-2">
                    <label>Sub Section Description</label>
                    <textarea type="text" class="form-control" placeholder="Ex. Sub Section Description"
                        id="SubSectionDescription" name="SubSectionDescription"
                        [(ngModel)]="this.Detail.SubSectionDescription" #SubSectionDescription="ngModel"
                        disabled></textarea>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-6 px-1 pt-2">
                    <label class="form-check-label link-dark px-1 mb-2" ngbButtonLabel>
                        <input class="form-check-input" type="checkbox" [value]=true name='IsOldRegimeApplicable'
                            [(ngModel)]="Detail.IsOldRegimeApplicable">
                        Old Regime Applicable
                    </label>
                    <br />
                    <label>Max Limit</label>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="IsOldMaxlimitapplicable">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsOldMaxlimitapplicable"
                                    name="IsOldMaxlimitapplicable" [(ngModel)]="Detail.IsOldMaxlimitapplicable"
                                    [disabled]="!Detail.IsOldRegimeApplicable">
                            </div>
                        </span>
                        <input type="text" class="form-control" placeholder="Ex. 1000" id="OldRegimeMaxAmount"
                            name="OldRegimeMaxAmount" [(ngModel)]="Detail.OldRegimeMaxAmount"
                            #OldRegimeMaxAmount="ngModel" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                            maxlength="6" [disabled]="!Detail.IsOldMaxlimitapplicable || !Detail.IsOldRegimeApplicable">
                        <div class="invalid-feedback">
                            Please enter max limit.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 px-1 pt-2">
                    <label class="form-check-label link-dark px-1 mb-2" ngbButtonLabel>
                        <input class="form-check-input" type="checkbox" [value]=true name='IsNewRegimeApplicable'
                            [(ngModel)]="Detail.IsNewRegimeApplicable">
                        New Regime Applicable
                    </label>
                    <br />
                    <label>Max Limit</label>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="IsNewMaxlimitapplicable">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsNewMaxlimitapplicable"
                                    name="IsNewMaxlimitapplicable" [(ngModel)]="Detail.IsNewMaxlimitapplicable"
                                    [disabled]="!Detail.IsNewRegimeApplicable">
                            </div>
                        </span>
                        <input type="text" class="form-control" placeholder="Ex. 1000" id="NewRegimeMaxAmount"
                            name="NewRegimeMaxAmount" [(ngModel)]="Detail.NewRegimeMaxAmount"
                            #NewRegimeMaxAmount="ngModel" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                            maxlength="6" [disabled]="!Detail.IsNewMaxlimitapplicable || !Detail.IsNewRegimeApplicable">
                        <div class="invalid-feedback">
                            Please enter max limit.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button
                        *ngIf="(this.Detail.ESS_TaxSubSectionFYMasterID == 0  && this.common.PageRight.IsAdd) || (this.Detail.ESS_TaxSubSectionFYMasterID > 0 && this.common.PageRight.IsEdit)"
                        type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>

    </div>
</form>